import React from 'react';
import './Footer.css';

export const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>About</h4>
          <p>
            ClimatePlans.org is a project of the{' '}
            <a 
              href="https://coolclimate.org/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-link"
            >
              CoolClimate Network
            </a>{' '}
            at the University of California, 
            in collaboration with Stopwaste.org, Universities and funders.
          </p>
        </div>
        
        <div className="footer-section">
          <h4>Funders</h4>
          <p>
            Seed funding provided by the University of California Office of the President's{' '}
            <a 
              href="https://uckeepresearching.org/california-climate-action/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-link"
            >
              California Climate Action Initiative
            </a>.
          </p>
        </div>
        

      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2025 ClimatePlans.org. All rights reserved.</p>
      </div>
    </footer>
  );
};
